import {Component, OnInit} from '@angular/core';
import {AngularFireDatabase} from 'angularfire2/database';
import {AngularFireAuth} from 'angularfire2/auth';
import {TimeTrackerService} from '../time-tracker-service.service';
import {User} from '../../models/User';
import {MatAutocompleteSelectedEvent, MatListOption, MatSnackBar} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import {Observable} from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import {Subscription} from 'rxjs/Subscription';
import {map} from 'rxjs/operators';
import {FormControl} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {Schedule} from '../../models/Schedule';
import * as moment from 'moment';
import {ScheduleService} from '../services/ScheduleService';
import {isArray, isUndefined} from 'util';
import {Team} from '../../models/team';
import * as XLSX from 'xlsx';
import {Device} from '../../models/device';
import {Check} from '../../models/Check';
import {Reason} from '../../models/Reason';
import {Company} from '../../models/company';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
    fromDate: Date;
    toDate: Date;

    myControl: FormControl;
    companyId: string;
    user: Observable<firebase.User>;
    userSubscription: Subscription;
    userInfo: User;

    listUsersForTeam: User[];
    selection = new SelectionModel<User>(true, []);

    filteredOptions: Observable<User[]>;
    usersSelected: Array<User> = [];

    listTeams: Array<Team> = [];
    totalListUsers: Array<User> = [];

    usersReport: Array<User> = [];
    reportLoadingStatus: Number = 0;

    isGeneratingReport: Boolean = false;

    subCompanyGroups: Array<Company> = [];

    constructor(public afAuth: AngularFireAuth, public af: AngularFireDatabase, public trans: TranslateService,
                public tts: TimeTrackerService, public snackBar: MatSnackBar,
                public scheduleService: ScheduleService) {
        this.user = this.afAuth.authState;
    }

    toMoment(date: any, isHour: boolean) {
        if (isHour) {
            const _moment = moment();
            _moment.hours(date.split(':')[0]);
            _moment.minutes(date.split(':')[1]);
        } else {
            return moment(date);
        }
    }

    ngOnInit() {
        this.fromDate = new Date();
        this.toDate = new Date();
        this.fromDate.setDate(1);
        this.myControl = new FormControl();

        this.userSubscription = this.user.subscribe(userPayloadInfo => {
            this.userSubscription.unsubscribe();
            if (userPayloadInfo) {
                this.tts.getUserFromId(userPayloadInfo.uid, userProfile => {
                    this.userInfo = userProfile.payload.val();
                    this.companyId = this.userInfo.companyId;
                    this.loadChildCompanies();
                    this.loadDataFromCompany();
                });
            }
        });
    }

    add(event: MatAutocompleteSelectedEvent): void {
        this.usersSelected.push(event.option.value);
    }

    remove(user: User): void {
        const index = this.usersSelected.indexOf(user);
        if (index >= 0) {
            this.usersSelected.splice(index, 1);
        }
    }

    /**
     * Parse to start|end date
     * @param {Date} date model
     * @param {string} type START|END
     * @returns {any} Date
     */
    getParsedTimes(date: Date, type: string): any {
        if (type === 'START') {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
        } else if (type === 'END') {
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            date.setMilliseconds(999);
        }
        return date;
    }

    generateReportByTeams(teamsSelectionModel) {
        if (!teamsSelectionModel) {
            return;
        }
        this.totalListUsers = [];
        const teamsListOptions: Array<MatListOption> = teamsSelectionModel.selected;
        if (teamsListOptions.length === 0) {
            this.usersSelected = [];
            this.isGeneratingReport = false;
            return;
        }
        let currentTeamUsersLoaded = 0;
        console.log(teamsListOptions);
        teamsListOptions.forEach(teamOption => {
            const team = teamOption.value;
            this.af.list<User>(TimeTrackerService.USERS, query => query.orderByChild('teamId').equalTo(team.id))
                .valueChanges()
                .subscribe(listUsers => {
                    let listActiveUsers = [];
                    for (let user in listUsers) {
                        if (listUsers[user].active) {
                            listActiveUsers.push(listUsers[user]);
                        }
                    }
                    this.totalListUsers = this.totalListUsers.concat(listActiveUsers);
                    currentTeamUsersLoaded++;
                    if (currentTeamUsersLoaded === teamsListOptions.length) {
                        this.usersSelected = this.totalListUsers;
                        this.generateReport(this.totalListUsers);
                    }
                });
        });
    }

    downloadCsv() {
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        console.log('-----> TABLE REPORT <------');
        console.log(this.usersReport);

        this.usersReport.forEach(user => {
            const row: Array<Array<string>> = [];

            let maxChecks = 0;

            user.checks.forEach(checkDay => {
                maxChecks = (checkDay.checks && checkDay.checks.length > maxChecks) ? checkDay.checks.length : maxChecks; // checksUsed
            });


            let indexRow = 0;
            row[indexRow] = [];
            // row[indexRow][0] = user.username; // Max 31 characters for sheet name
            row[indexRow][0] = 'Nombre'; // XLSX.utils.encode_cell(cell_address);
            row[indexRow][1] = user.username;
            // XLSX.utils.encode_cell({c: indexRow, r: 1, V: user.username})

            indexRow++;
            row[indexRow] = [];
            row[indexRow][0] = 'Ci';
            row[indexRow][1] = user.ci;

            indexRow++;
            row[indexRow] = [];
            row[indexRow][0] = 'Horario';
            row[indexRow][1] = this.scheduleService.generateSimpleVerboseSchedule(user.schedule);

            indexRow++;
            row[indexRow] = [];
            row[indexRow][0] = 'Fecha';
            row[indexRow][1] = 'De ' + this.toMoment(this.fromDate, false).format('YYYY-MM-DD') + ' al ' +
                this.toMoment(this.toDate, false).format('YYYY-MM-DD');

            indexRow++;
            row[indexRow] = [];
            row[indexRow][0] = '';

            row[indexRow][maxChecks * 3 + 2] = 'Atrasos';
            row[indexRow][maxChecks * 3 + 3] = 'Total';

            user.checks.forEach(checkDay => {
                indexRow++;
                row[indexRow] = [];
                row[indexRow][0] = checkDay.day;

                if (checkDay.checks) { // or use checksUsed
                    let indexCol = 1;
                    checkDay.checks.forEach(check => {
                        row[indexRow][indexCol++] = check.event; // set Event (IN, OUT)
                        if (check.type == Check.TYPE_FORCED) {
                            row[indexRow][indexCol++] =
                                check.type + ' (' + this.toMoment(check.timeStamp, false)
                                    .format('YYYY-MM-DD HH:mm') + ')'; // set type (FORCED DATE HOUR)
                        } else {
                            row[indexRow][indexCol++] = check.type; // Set type (NORMAL)
                        }
                        row[indexRow][indexCol++] = this.toMoment(check.date, false).format('HH:mm'); // set time (HH:mm)
                    });
                }

                row[indexRow][maxChecks * 3 + 2] = this.scheduleService.millisToSimpleStringVerbose(checkDay.delay); // Set total delay
                row[indexRow][maxChecks * 3 + 3] = this.scheduleService.millisToSimpleStringVerbose(checkDay.work);  // Set total work
            });

            console.log(row);
            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(row);

            XLSX.utils.book_append_sheet(wb, ws, user.username.substring(0, 30));
        });

        // XLSX.utils.book_append_sheet(wb, ws, 'Report2');
        const wbout: ArrayBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
        const blob = new Blob([wbout], {type: 'application/octet-stream'});
        const link = document.createElement('a');
        link.setAttribute('href', URL.createObjectURL(blob));
        link.setAttribute('download', 'Report from ' +
            this.toMoment(this.fromDate, false).format('YYYY-MM-DD') + ' to ' +
            this.toMoment(this.toDate, false).format('YYYY-MM-DD') + '.xls');
        document.body.appendChild(link); // Required for FF
        link.click();
    }

    updateLoading(isLoading: Boolean) {
        this.reportLoadingStatus = 1;
        setTimeout(() => {
            this.reportLoadingStatus = 2;
        }, 2100);
    }

    generateReport(users: Array<User>) {
        if (!(this.fromDate && this.toDate)) {
            this.trans.get('REPORTS.FROM_AND_TO_DATE_IS_REQUIRED').subscribe((res: string) => {
                this.snackBar.open(res, null, {duration: 2500});
            });
            return;
        }
        if (!users || users.length === 0) {
            this.usersSelected = [];
            this.isGeneratingReport = false;
            return;
        }

        this.fromDate = this.getParsedTimes(this.fromDate, 'START');
        this.toDate = this.getParsedTimes(this.toDate, 'END');

        this.isGeneratingReport = true;
        this.usersReport = users;

        this.reportLoadingStatus = 1;

        users.forEach(user => {

            // Generate report only for active users
            if (!user.active) {
                return;
            }
            user.checks = [];

            // Checks
            this.tts.getChecks(user.id, user.companyId, this.fromDate.getTime(), this.toDate.getTime(), allChecks => {
                user.checks = this.scheduleService.splitPerDay(allChecks);
                console.log('Checks:   ', JSON.stringify(user), user);
                //  Schedule
                const subs = this.af.list<Schedule>(TimeTrackerService.SCHEDULES,
                    query => query.orderByChild('userId').equalTo(user.id))
                    .valueChanges().subscribe(ref => {
                        subs.unsubscribe();
                        if (ref.length > 0) {
                            user.schedule = ref[0].schedule;
                            // Load Reasons
                            this.af.list<Reason>(TimeTrackerService.COMPANY_DATA + '/' + user.companyId + '/' + TimeTrackerService.REASONS,
                                query => query.orderByChild('date').startAt(this.fromDate.getTime()).endAt(this.toDate.getTime()))
                                .valueChanges().subscribe(exceptions => {
                                    this.updateLoading(true);
                                    user.checks.forEach(checkDays => {
                                        checkDays.checksUsed = [];
                                        checkDays.delay = 0;
                                        checkDays.work = 0;

                                        const day = this.scheduleService.getDayFromDate(checkDays.day);
                                        const scheduleHour = !isUndefined(user.schedule[day]) ? user.schedule[day].hours : Array();
                                        const reason = this.scheduleService.getReasonByDate(exceptions, checkDays.day);
                                        const checksUsedDelay = this.scheduleService.getTimeDelaySaveHours(
                                            checkDays.checks, scheduleHour, reason);
                                        checkDays.checksUsed = checksUsedDelay.checksUsed || [];
                                        checkDays.delay = checksUsedDelay.delay;
                                        checkDays.work = checksUsedDelay.work;
                                    });
                                }
                            );
                        } else {
                            this.updateLoading(true);
                            this.trans.get('REPORTS.PLEASE_ASSIGN_SCHEDULE_FOR_ALL_USERS').subscribe((res: string) => {
                                this.snackBar.open(res + ': ' + user.username, null, {duration: 5000});
                            });
                        }
                        this.isGeneratingReport = false;
                    });
            });
        });
    }

    public getAllUsers(companyId) {
        this.af.list<User>(TimeTrackerService.USERS, query => query.orderByChild('companyId').equalTo(companyId))
            .valueChanges()
            .subscribe(listUsers => {
                this.listUsersForTeam = listUsers;
                this.filteredOptions = this.myControl.valueChanges
                    .pipe(
                        map(inputText => inputText && typeof inputText === 'object' ? inputText.username : inputText),
                        map(inputText => inputText ? this.filter(inputText) : this.listUsersForTeam)
                    );
            });
    }

    filter(username: string): User[] {
        return this.listUsersForTeam.filter(option =>
            option.username.toLowerCase().indexOf(username.toLowerCase()) === 0 ||
            option.ci.toLowerCase().indexOf(username.toLowerCase()) === 0
        );
    }

    displayFn(user: User): string {
        return user ? (user.username + ' - ' + user.ci) : '';
    }

    /**
     * @param {Array<any>} userAllChecks
     * @param {string} param  delay|work
     * @returns {number}
     */
    public getTotalSum(userAllChecks: Array<any>, param: string): number {
        if (!isArray(userAllChecks)) {
            return 0;
        }

        let delay = 0;
        userAllChecks.forEach(checkDays => {
            delay += (checkDays[param] ? checkDays[param] : 0);
        });
        return delay;
    }

    public loadDeviceFromMac(check: Check): Device {
        console.log(check);
        const mac = check.mac;
        if (!mac) {
            return;
        }
        this.af.list<Device>(TimeTrackerService.USER_DEVICES, query => query.orderByChild('mac').equalTo(mac))
            .valueChanges()
            .subscribe(devices => {
                console.log(devices);
                if (devices && devices.length > 0) {
                    const device = devices[0];
                    this.tts.getUserFromId(device.userId, data => {
                        const user = data.payload.val();
                        check.user = user;
                        console.log('  getUserFromId-> ', data, user);
                    });
                }
            });
    }

    public loadDataFromCompany() {
        // selectedOptions
        console.log('Selected Company: ' + this.companyId);
        this.getAllUsers(this.companyId);
        // this.teamsSelectionList = [];
        this.tts.getTeamsFromCompany(this.companyId, teams => {
            this.listTeams = teams;
        });
    }

    public loadChildCompanies() {
        this.subCompanyGroups = [];
        this.tts.getCompanyFromId(this.userInfo.companyId, rootCompany => {
            this.subCompanyGroups.push(rootCompany);
            this.tts.getChildGroups(rootCompany.id, data => {
                this.subCompanyGroups = this.subCompanyGroups.concat(data);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts